module.exports = __webpack_public_path__ + "82841a321decc868f76ec08746034d0b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/doctor-bag.png
// module id = 2015
// module chunks = 0